document.addEventListener("DOMContentLoaded", async () => {
  // ############# TOC ###############

  const pageHeader = document.querySelector(".section-header");
  const headerHeight = getComputedStyle(pageHeader).height;
  const tocAside = document.querySelector(".blog-post-content__aside");
  window.addEventListener("scroll", () => {
    const isHeaderHidden = pageHeader.classList.contains(
      "shopify-section-header-hidden"
    );

    if (isHeaderHidden) {
      tocAside.style.top = "";
    } else {
      tocAside.style.top = parseInt(headerHeight) + 16 + "px";
    }
  });
  const articleHtml = document.querySelector("[data-role='article-content']");
  const titles = [...articleHtml.children].filter((item) =>
    item.tagName.startsWith("H")
  );
  if (titles.length === 0) {
    tocAside.style.display = "none";
  }

  const hierarchy = buildHierarchy(titles);
  const tocList = document.querySelector("#table-of-content ul");

  const tocHandle = document.querySelector(".toc-handle");
  tocHandle.addEventListener("click", (e) => {
    const isOpened = tocHandle.classList.contains("opened");
    if (isOpened) {
      tocList.parentElement.style.height = "0px";
      tocHandle.classList.remove("opened");
    } else {
      tocList.parentElement.style.height = "auto";
      tocHandle.classList.add("opened");
    }
  });

  hierarchy.forEach((hierarchyItem) => {
    const tocListItem = createTOCListItem({ hierarchyItem });
    if (tocListItem) tocList.append(tocListItem);
  });

  function buildHTMLElementNode(element) {
    return {
      element: element,
      children: [],
      addChild: function (child) {
        this.children.push(child);
      },
    };
  }

  function buildHierarchy(titles) {
    const root = buildHTMLElementNode(null);
    let hierarchyStack = [{ node: root, level: 0 }];

    for (const title of titles) {
      const level = parseInt(title.tagName.slice(1));
      const node = buildHTMLElementNode(title);

      while (
        hierarchyStack.length > 0 &&
        hierarchyStack[hierarchyStack.length - 1].level >= level
      ) {
        hierarchyStack.pop();
      }

      if (hierarchyStack.length > 0) {
        hierarchyStack[hierarchyStack.length - 1].node.addChild(node);
      }

      hierarchyStack.push({ node: node, level: level });
    }

    return root.children;
  }

  function createTOCListItem({ hierarchyItem }) {
    const heading = hierarchyItem.element;
    if (!heading.innerText) return;
    heading.id = encodeURIComponent(heading.innerText);
    const li = document.createElement("li");

    const a = document.createElement("a");
    a.href = "javascript:void(0);";
    a.innerText = heading.innerText.replace(/(\r\n|\n|\r)/g, "");
    li.appendChild(a);

    if (hierarchyItem.children.length > 0) {
      li.classList.add("toc--list-item__with-children");
      const childUl = document.createElement("ul");
      childUl.classList.add("toc--list-item__children");
      hierarchyItem.children.forEach((child) => {
        const childLi = createTOCListItem({ hierarchyItem: child });
        if (childLi) childUl.appendChild(childLi);
      });

      li.appendChild(childUl);

      li.addEventListener("click", (e) => {
        e.stopPropagation();
        const isOpened = childUl.classList.contains("open");
        childUl.classList.toggle("open");
        childUl.style.height = isOpened ? 0 : "auto";
        li.classList.toggle("toc--list-item__with-children__opened");
      });
    }

    a.addEventListener("click", (e) => {
      e.stopPropagation();
      const headerOffset = 124;
      const elementPosition = heading.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    });

    return li;
  }

  // ############# TOC ###############
  // METAFIELD VARIANT AND PRODUCTS START
  // VARIABLES blog_single_variant blog_list_variant blog_single_product blog_list_product productCardImages
  // PARAGRAPH CONTENTS ###variant### | ###variant_list### | ###product### | ###product_list###
  const imageZoomIn = new CustomEvent("imageZoomIn"); //IMAGE ZOOM CUSTOM EVENT
  const imageZoomOut = new CustomEvent("imageZoomOut"); //IMAGE ZOOM CUSTOM EVENT
  const updateZoomButtons = new CustomEvent("updateZoomButtons");

  const CART_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10.975 8l.025-.5c0-.517-.067-1.018-.181-1.5h5.993l-.564 2h-5.273zm-2.475 10c-.828 0-1.5.672-1.5 1.5 0 .829.672 1.5 1.5 1.5s1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm11.305-15l-3.432 12h-10.428l-.455-1.083c-.323.049-.653.083-.99.083-.407 0-.805-.042-1.191-.114l1.306 3.114h13.239l3.474-12h1.929l.743-2h-4.195zm-6.305 15c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm-4.5-10.5c0 2.485-2.018 4.5-4.5 4.5-2.484 0-4.5-2.015-4.5-4.5s2.016-4.5 4.5-4.5c2.482 0 4.5 2.015 4.5 4.5zm-2-.5h-2v-2h-1v2h-2v1h2v2h1v-2h2v-1z"/></svg>`;
  const MAGNIFIER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.172 24l-7.387-7.387c-1.388.874-3.024 1.387-4.785 1.387-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9c0 1.761-.514 3.398-1.387 4.785l7.387 7.387-2.828 2.828zm-12.172-8c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7z"/></svg>`;
  const CHEVRON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>`;
  const CLOSE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>`;
  const ZOOM_OUT_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13 10h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2zm8.172 14l-7.387-7.387c-1.388.874-3.024 1.387-4.785 1.387-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9c0 1.761-.514 3.398-1.387 4.785l7.387 7.387-2.828 2.828zm-12.172-8c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7z"/></svg>`;
  const ZOOM_IN_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13 10h-8v-2h8v2zm8.172 14l-7.387-7.387c-1.388.874-3.024 1.387-4.785 1.387-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9c0 1.761-.514 3.398-1.387 4.785l7.387 7.387-2.828 2.828zm-12.172-8c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7z"/></svg>`;

  const SHOPIFY_STORE_URL = "/api/2024-07/graphql";
  const ACCESS_TOKEN = "f9fc16778c38a20175fd2250596f87be";

  const productHandlesToFetch = [];
  const atcButton = document.querySelector(".article-atc");
  const articleContent = document.querySelector(
    "[data-role='article-content']"
  );
  const articleParagraphs = articleContent.querySelectorAll("p");
  const isUSA =
    new URL(window.location.href).host === "throttleresponsecontroller.com";
  const isPreview = new URL(window.location.href).host.includes(
    "shopifypreview"
  );
  const isTest =
    new URL(window.location.href).searchParams.get("test") === "true";

  // if (isPreview || isTest) {
  //   const relatedCards = document.querySelectorAll(".related-article-button");
  //   relatedCards.forEach((card) => {
  //     card.href = card.href + "?test=true";
  //   });

  //   const linksWithErrorsContainer = document.createElement("div");
  //   const linksWithErrorsContainerInfo = document.createElement("p");
  //   linksWithErrorsContainerInfo.textContent =
  //     "This functionality is only visible in preview mode or test mode.";
  //   linksWithErrorsContainer.appendChild(linksWithErrorsContainerInfo);
  //   linksWithErrorsContainer.style =
  //     "position:fixed;bottom:0;left:0;z-index:9999;background:#ffcc33;border:2px solid black;padding:10px;max-height:200px;overflow-y:auto";

  //   const allContentLinks = articleContent.querySelectorAll("a");

  //   let isAlerted = false;
  //   allContentLinks.forEach((item) => {
  //     const itemHref = item.outerHTML.match(/href="([^"]*)"/)?.[1];
  //     if (itemHref.includes("pedalcommander.com")) {
  //       if (!isAlerted) {
  //         isAlerted = true;
  //         window.alert("There is a link to pedalcommander.com");
  //       }
  //       const handle = document.createElement("p");
  //       handle.textContent = "- " + itemHref;
  //       handle.style.cursor = "pointer";
  //       handle.addEventListener("click", () => {
  //         allContentLinks.forEach((x) => {
  //           x.style.border = "none";
  //         });
  //         item.style.border = "2px solid red";
  //         item.scrollIntoView({ behavior: "smooth", block: "center" });
  //       });
  //       linksWithErrorsContainer.appendChild(handle);
  //     }
  //   });

  //   if (linksWithErrorsContainer.children.length > 0)
  //     document.body.appendChild(linksWithErrorsContainer);
  // }

  articleParagraphs.forEach(async function (paragraph) {
    const textContent = paragraph.textContent.trim();

    // //STARTS WITH ### but not ###img_gal###
    if (/^###(?!img_gal###)/.test(textContent) && !isUSA && !isPreview) {
      // IF MARKET IS NOT USA AND CONTENT IS NOT IMAGE GALLERY REMOVE THE CONTENT
      paragraph.remove();
      return;
    }

    if (textContent === "###variant###") {
      // const variantButton = getVariantButton(window.blog_single_variant);
      const isPreviousElementButton =
        paragraph.previousElementSibling.classList.contains(
          "section_opener_button"
        );
      const variantsList = getVariantContainer(
        [window.blog_single_variant],
        isPreviousElementButton
      );
      paragraph.replaceWith(variantsList);
    } else if (textContent === "###variant_list###") {
      const isPreviousElementButton =
        paragraph.previousElementSibling.classList.contains(
          "section_opener_button"
        );
      const variantsList = getVariantContainer(
        window.blog_list_variant,
        isPreviousElementButton
      );
      paragraph.replaceWith(variantsList);
    } else if (textContent === "###product###") {
      const isPreviousElementButton =
        paragraph.previousElementSibling.classList.contains(
          "section_opener_button"
        );
      const productsList = getProductContainer(
        [window.blog_single_product],
        isPreviousElementButton
      );
      paragraph.replaceWith(productsList);
    } else if (textContent === "###product_list###") {
      const isPreviousElementButton =
        paragraph.previousElementSibling.classList.contains(
          "section_opener_button"
        );
      const productsList = getProductContainer(
        window.blog_list_product,
        isPreviousElementButton
      );
      paragraph.replaceWith(productsList);
    } else if (
      textContent.startsWith("###btn###") &&
      textContent.endsWith("###btn###")
    ) {
      const sectionOpenerButton = getSectionOpenerButton(textContent);
      paragraph.replaceWith(sectionOpenerButton);
    } else if (
      textContent.startsWith("###img_gal###") &&
      textContent.endsWith("###img_gal###")
    ) {
      const imageGallery = await getImageGallery(textContent);
      if (imageGallery) {
        paragraph.replaceWith(imageGallery);
      } else {
        paragraph.remove();
      }
    } else if (textContent.startsWith("###product_handle###")) {
      const rawHandle = textContent.replaceAll("###product_handle###", "");
      const parsedHandle = rawHandle.split("/");
      const handle = parsedHandle[parsedHandle.length - 1];
      productHandlesToFetch.push(handle);
      paragraph.dataset.productHandle = handle; // sets a data-attr to get later
    }
  });

  // FUNCTIONS
  // PRODUCT WITH HANDLE START
  let productsWithHandles = [];
  if (productHandlesToFetch.length > 0) {
    productsWithHandles = await fetchProductViaHandles(productHandlesToFetch);
  }
  productsWithHandles.forEach((product) => {
    const pElement = articleContent.querySelector(
      `p[data-product-handle='${product.handle}']`
    );
    const isPreviousElementButton =
      pElement.previousElementSibling.classList.contains(
        "section_opener_button"
      );
    const productContainer = getProductContainer(
      [product],
      isPreviousElementButton
    );
    pElement.replaceWith(productContainer);
  });
  async function fetchProductViaHandles(handles) {
    const query = `
                    query {
                      ${handles
                        .map((handle, i) => {
                          return `product_${i}: productByHandle(handle: "${handle}") {
                                id
                                title
                                handle
                                title
                                variants(first: 250) {
                                nodes {
                                    id
                                    title
                                    price {
                                      amount
                                    }
                                    compareAtPrice {
                                      amount
                                    }
                                  }
                                } 
                                image: metafield(namespace: "header", key: "image-headerIntro") {
                                  key
                                  namespace
                                  value
                                  type
                                  reference {
                                    ... on MediaImage {
                                      id
                                      image {
                                        originalSrc
                                        altText
                                      }
                                    }
                                  }
                                }
                              }`;
                        })
                        .join("")}
                    }
                    `;

    try {
      const response = await fetch(SHOPIFY_STORE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      });

      const data = await response.json();
      if (!data.data) throw new Error("No response");
      const products = Object.values(data.data);
      products.forEach((product) => {
        // Check if the handle is not already present in window.productCardImages
        const isHandlePresent = window.productCardImages.some(
          (item) => item.handle === product.handle
        );
        if (!isHandlePresent) {
          window.productCardImages.push({
            handle: product.handle,
            image: product.image.reference.image.originalSrc,
          });
        }
      });
      return products.map((product) => {
        // Multiplied by 100 because data comes from shopify in this form inside liquid files
        const price = Number(product.variants.nodes[0].price.amount) * 100;
        const compare_at_price =
          Number(product.variants.nodes[0].compareAtPrice.amount) * 100;

        return {
          handle: product.handle,
          title: product.title,
          price,
          compare_at_price,
          variants: product.variants.nodes.map((node) => {
            const splittedId = node.id.split("/");
            return {
              ...node,
              id: splittedId[splittedId.length - 1],
            };
          }),
        };
      });
    } catch (err) {
      console.error(err);
    }
  }
  // PRODUCT WITH HANDLE END
  /*########################*/
  // IMAGE GALLERY START
  async function getImageGallery(textContent) {
    const handle = textContent.replaceAll("###img_gal###", "");
    const query = `
                          query getMetaobjectWithImages {
                            metaobject(handle: { type: "blog_post_image_gallery", handle: "${handle}" }) {
                              id
                              handle
                              field(key: "images") {
                                value
                              }
                            }
                          }
                        `;
    try {
      const response = await fetch(SHOPIFY_STORE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      });

      const data = await response.json();
      const imageIds = data.data.metaobject.field.value;
      const imageSources = await fetchImageSources(imageIds);
      const swipersHTML = createImageSwipers(imageSources);
      return swipersHTML;
    } catch (error) {
      console.error(`There is no image gallery with handle:"${handle}"`);
      console.error(error);
      return null;
    }
  }

  async function fetchImageSources(images) {
    const query = `
                        {
                          nodes(ids: ${images}) {
                            ... on MediaImage {
                              id
                              image {
                                id
                                transformedSrc(maxWidth:750)
                              }
                            }
                          }
                        }
                        `;

    try {
      const response = await fetch(SHOPIFY_STORE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      });

      const data = await response.json();
      const images = data.data.nodes.map((node) => node.image.transformedSrc);
      return images;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  function createImageSwipers(image_sources) {
    const html = `
                      <div class="article-image-gallery-container">
                          <div class="swiper article-image-gallery-swiper">
                              <div class="swiper-wrapper">
                                  ${image_sources
                                    .map((src) => {
                                      return `
                                      <div class="swiper-slide">
                                          <img src="${src}"/>
                                      </div>
                                      `;
                                    })
                                    .join("")}
                              </div>
                              <div class="swiper-button-next article-image-gallery-nav">${CHEVRON_SVG}</div>
                              <div class="swiper-button-prev article-image-gallery-nav">${CHEVRON_SVG}</div>
                          </div>
                          <div class="swiper article-image-gallery-thumbs">
                              <div class="swiper-wrapper">
                                  ${image_sources
                                    .map((src) => {
                                      return `
                                      <div class="swiper-slide">
                                          <img src="${src}"/>
                                      </div>
                                      `;
                                    })
                                    .join("")}
                              </div>
                          </div>
                      </div>`;

    const tempDiv = document.createElement("div"); // converts string html to dom
    tempDiv.innerHTML = html;

    // initiate swipers
    const thumbs = new Swiper(
      tempDiv.querySelector(".article-image-gallery-thumbs"),
      {
        spaceBetween: 8,
        slidesPerView: image_sources.length < 4 ? image_sources.length : 4,
        freeMode: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        on: {
          init: function () {
            setTimeout(() => {
              // fix: thumb do not render in correct starting position without this
              this.wrapperEl.style.transform = "translate3d(0px, 0px, 0px)";
            }, 200);
          },
        },
      }
    );

    const swiper = new Swiper(
      tempDiv.querySelector(".article-image-gallery-swiper"),
      {
        spaceBetween: 8,
        slidesPerView: 1,
        thumbs: {
          swiper: thumbs,
        },
        navigation: {
          nextEl: tempDiv.querySelector(".swiper-button-next"),
          prevEl: tempDiv.querySelector(".swiper-button-prev"),
        },
        on: {
          slideChange: () => {
            thumbs.slideTo(swiper.activeIndex);
          },
        },
      }
    );

    const mainSlidersImages = tempDiv.querySelectorAll(
      ".article-image-gallery-swiper img"
    );
    mainSlidersImages.forEach((image, i) => {
      image.addEventListener("click", () => {
        if (window.innerWidth > 786) {
          createZoomModal(
            image_sources.map((item) => item.replace(/_\d+x/, "")),
            i
          );
        }
      });
    });
    return tempDiv.firstElementChild;
  }

  let modalRef = null;
  function createZoomModal(sources, startIndex) {
    const modalContainer = document.createElement("div");
    modalRef = modalContainer;
    modalContainer.classList.add("zoom-modal-container");
    modalContainer.dataset.closeModal = "true";

    const innerHtml = `
                    <div class="modal-content">
                      <div class="modal-controls">
                          <div class="control disabled" data-role="out">${ZOOM_IN_SVG}</div>
                          <div class="control" data-role="in">${ZOOM_OUT_SVG}</div>
                          <div class="control" data-close-modal="true">${CLOSE_SVG}</div>
                      </div>
                      <div class="swiper zoom-modal-main-swiper">
                          <div class="swiper-wrapper">
                          ${sources
                            .map((src) => {
                              return `
                              <div class="swiper-slide">
                                  <img src="${src}" draggable="false" style="transform: scale3d(1, 1, 1);" />
                              </div>
                              `;
                            })
                            .join("")}
                          </div>
                          <div class="swiper-button-next article-image-gallery-nav">${CHEVRON_SVG}</div>
                          <div class="swiper-button-prev article-image-gallery-nav">${CHEVRON_SVG}</div>
                      </div>
                      <div class="swiper zoom-modal-thumbs-swiper">
                          <div class="swiper-wrapper">
                          ${sources
                            .map((src) => {
                              return `
                              <div class="swiper-slide">
                                  <img src="${src}" />
                              </div>
                              `;
                            })
                            .join("")}
                          </div>    
                      </div>
                    </div>
                    `;
    modalContainer.innerHTML = innerHtml;

    modalContainer.addEventListener("mousedown", (e) => {
      if (e.target.dataset.closeModal === "true") {
        closeZoomModal();
      }
    });

    // Initialize Swipers
    const thumbsSwiper = new Swiper(
      modalContainer.querySelector(".zoom-modal-thumbs-swiper"),
      {
        spaceBetween: 8,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        initialSlide: startIndex,
        on: {
          afterInit: function () {
            setTimeout(() => {
              // fix: thumb do not render in correct starting position without this
              if (startIndex === 0)
                this.wrapperEl.style.transform = "translate3d(0px, 0px, 0px)";
            }, 200);
          },
        },
      }
    );
    const mainSwiper = new Swiper(
      modalContainer.querySelector(".zoom-modal-main-swiper"),
      {
        initialSlide: startIndex,
        keyboard: {
          enabled: true,
        },
        //   allowTouchMove: false,
        spaceBetween: 8,
        thumbs: {
          swiper: thumbsSwiper,
        },
        on: {
          slideChange: (slider) => {
            thumbsSwiper.slideTo(slider.activeIndex);
            const image =
              slider.slides[slider.activeIndex]?.querySelector("img");
            image?.dispatchEvent(updateZoomButtons);
          },
        },
        navigation: {
          nextEl: modalContainer.querySelector(".swiper-button-next"),
          prevEl: modalContainer.querySelector(".swiper-button-prev"),
        },
      }
    );

    // Add zoom and drag functionality
    const slides = modalContainer.querySelectorAll(
      ".zoom-modal-main-swiper .swiper-slide img"
    );

    const zoomOutButton = modalContainer.querySelector(
      `.control[data-role='out']`
    );
    slides.forEach((img) => {
      // Handle drag move
      let zoomFactor = 1;
      let isDragging = false;
      let lastMouseX = 0;
      let lastMouseY = 0;
      let translateXPercent = 0;
      let translateYPercent = 0;
      const moveMultiplier = 1.5; // Adjust this value to control the movement speed

      img.addEventListener("imageZoomIn", () => {
        zoomFactor += 0.5;
        img.style.cursor = "grab";
        zoomOutButton.classList.remove("disabled");
        mainSwiper.allowTouchMove = false;
        updateTransform();
      });

      img.addEventListener("imageZoomOut", () => {
        zoomFactor = Math.max(zoomFactor - 0.5, 1);
        if (zoomFactor === 1) {
          img.style.cursor = "";
          mainSwiper.allowTouchMove = true;
          zoomOutButton.classList.add("disabled");
        }
        const maxTranslateX = (zoomFactor - 1) * 50;
        const maxTranslateY = (zoomFactor - 1) * 50;

        translateXPercent = Math.min(
          Math.max(translateXPercent, -maxTranslateX),
          maxTranslateX
        );
        translateYPercent = Math.min(
          Math.max(translateYPercent, -maxTranslateY),
          maxTranslateY
        );
        updateTransform();
      });

      img.addEventListener("updateZoomButtons", () => {
        if (zoomFactor === 1) {
          zoomOutButton.classList.add("disabled");
          return;
        }
        zoomOutButton.classList.remove("disabled");
      });

      // Drag functionality
      img.addEventListener("mousedown", (event) => {
        isDragging = true;
        lastMouseX = event.clientX;
        lastMouseY = event.clientY;
        img.style.cursor = "grabbing";
      });

      document.addEventListener("mousemove", (event) => {
        if (!isDragging) return;

        const deltaX =
          (event.clientX - lastMouseX) * (moveMultiplier * zoomFactor); // Apply multiplier
        const deltaY =
          (event.clientY - lastMouseY) * (moveMultiplier * zoomFactor); // Apply multiplier

        // Calculate percentage translation
        const imgWidth = img.clientWidth * zoomFactor;
        const imgHeight = img.clientHeight * zoomFactor;

        translateXPercent += (deltaX / imgWidth) * 100;
        translateYPercent += (deltaY / imgHeight) * 100;

        // Constrain translation to image borders
        const maxTranslateX = (zoomFactor - 1) * 50;
        const maxTranslateY = (zoomFactor - 1) * 50;

        // Apply constraints
        translateXPercent = Math.min(
          Math.max(translateXPercent, -maxTranslateX),
          maxTranslateX
        );
        translateYPercent = Math.min(
          Math.max(translateYPercent, -maxTranslateY),
          maxTranslateY
        );

        // Update transform
        updateTransform();

        lastMouseX = event.clientX;
        lastMouseY = event.clientY;
      });

      document.addEventListener("mouseup", () => {
        isDragging = false;
        img.style.cursor = zoomFactor === 1 ? "" : "grab";
      });

      // Update the transform property of the image
      function updateTransform() {
        img.style.transform = `translate(${translateXPercent}%, ${translateYPercent}%) scale3d(${zoomFactor}, ${zoomFactor}, 1)`;
      }
    });

    modalContainer.querySelectorAll(".control").forEach((item) => {
      item.addEventListener("click", (e) => {
        const role = e.target.dataset.role;
        const image =
          mainSwiper.slides[mainSwiper.activeIndex].querySelector("img");
        if (!image) return;
        if (role === "in") {
          image.dispatchEvent(imageZoomIn);
        }
        if (role === "out") {
          image.dispatchEvent(imageZoomOut);
        }
      });
    });

    // Append modal to the body
    // Append modal to the body
    setTimeout(async () => {
      try {
        document.body.style.overflow = "hidden";
        document.body.append(modalContainer);

        // Wait for the modal width to be adjusted
        await matchZoomModalWidth();

        // Proceed to calculate and set the max height
        const controls = modalContainer.querySelector(".modal-controls");
        const controlsHeight = parseInt(getComputedStyle(controls).height);
        const thumbsSwiperHeight = thumbsSwiper.height;

        const maxHeight = `calc(90vh - ${
          controlsHeight + thumbsSwiperHeight + 60
        }px)`;
        mainSwiper.wrapperEl.style.maxHeight = maxHeight;
        // Make the modal visible
        modalContainer.classList.add("visible");
      } catch (error) {
        console.error(
          "Error while setting modal width or height:",
          error.message
        );
      }
    }, 10);
  }
  async function matchZoomModalWidth() {
    return new Promise((resolve, reject) => {
      if (modalRef === null) {
        reject(new Error("Modal reference is null"));
        return;
      }

      const modalContainer = modalRef;
      const img = modalContainer.querySelector(".zoom-modal-main-swiper img");
      const modalContent = modalContainer.querySelector(".modal-content");

      if (!img || !modalContent) {
        reject(new Error("Image or modal content not found"));
        return;
      }

      const updateModalWidth = () => {
        const width = parseInt(getComputedStyle(img).width);
        modalContent.style.maxWidth = `${width + 32}px`;
        resolve(); // Resolve the promise after updating the modal width
      };

      if (img.complete) {
        // If the image is already loaded
        updateModalWidth();
      } else {
        // Wait for the image to load
        img.addEventListener("load", updateModalWidth, { once: true });
      }
    });
  }

  function closeZoomModal() {
    const modalContainer = modalRef;
    modalRef = null;
    modalContainer.remove();
    document.body.style.overflow = "";
  }

  // IMAGE GALLERY END

  function getProductContainer(products, isPreviousElementButton) {
    const listProductContainer = document.createElement("div");
    listProductContainer.dataset.role = "metafield-content";

    if (isPreviousElementButton) {
      listProductContainer.dataset.opened = "false";
    } else {
      listProductContainer.dataset.opened = "true";
      listProductContainer.classList.add("buttonless");
    }
    listProductContainer.classList.add("list-product-container");
    products.forEach((product) => {
      const imageSrc = window.productCardImages.find(
        (item) => item.handle === product.handle
      ).image;
      if (
        imageSrc.includes("/cdn/shop/files") ||
        imageSrc.includes("cdn.shopify.com")
      ) {
        const productCard = getProductCard(product);
        listProductContainer.append(productCard);
      }
    });

    return listProductContainer;
  }
  function getVariantContainer(variants, isPreviousElementButton) {
    const listVariantContainer = document.createElement("div");
    listVariantContainer.dataset.role = "metafield-content";

    if (isPreviousElementButton) {
      listVariantContainer.dataset.opened = "false";
    } else {
      listVariantContainer.dataset.opened = "true";
      listVariantContainer.classList.add("buttonless");
    }
    variants.forEach((variant) => {
      const variantButton = getVariantButton(variant);
      listVariantContainer.append(variantButton);
    });

    return listVariantContainer;
  }

  function getSectionOpenerButton(rawContent) {
    const content = rawContent.replaceAll("###btn###", "");
    const button = document.createElement("button");
    const buttonTextEl = document.createElement("p");
    const buttonChevronContainer = document.createElement("div");

    buttonChevronContainer.classList.add("button_chevron_container");
    buttonChevronContainer.innerHTML = CHEVRON_SVG;
    button.classList.add("section_opener_button");
    buttonTextEl.textContent = content;
    button.dataset.opened = "false";
    button.append(buttonTextEl);
    button.append(buttonChevronContainer);

    button.addEventListener("click", () => {
      let nextElement = button.nextElementSibling;

      while (nextElement) {
        if (nextElement.dataset.role === "metafield-content") {
          const isOpened = nextElement.dataset.opened === "true";

          if (!isOpened) {
            if (nextElement.classList.contains("list-product-container")) {
              nextElement.style.height = nextElement.scrollHeight + 36 + "px";
            } else {
              nextElement.style.height = nextElement.scrollHeight + "px";
            }
            nextElement.dataset.opened = "true";
            button.dataset.opened = "true";
          } else {
            nextElement.style.height = "0";
            nextElement.dataset.opened = "false";
            button.dataset.opened = "false";
          }

          break;
        }
        nextElement = nextElement.nextElementSibling;
      }
    });

    return button;
  }
  function getVariantButton(variant) {
    const [pcCode, make, model, body, engine] = variant.title
      .split("/")
      .map((item) => item.trim());
    const extractedPcCode = pcCode.match(/PC\d+/)?.[0];
    const isOutOfStock = window.outOfStockPcCodes?.includes(extractedPcCode);
    const variantButton = document.createElement("button");
    variantButton.classList.add("variant_button");
    if (isOutOfStock) {
      variantButton.classList.add("out_of_stock");
      variantButton.innerHTML = `<div class="out_of_stock_text">OUT OF STOCK</div>`;
    }
    const variantButtonTexts = document.createElement("div");
    variantButtonTexts.classList.add("variant_button_body_engine");

    const variantBodyEl = document.createElement("p");
    variantBodyEl.classList.add("variant_body");
    variantBodyEl.textContent = body;

    const variantEngineEl = document.createElement("p");
    variantEngineEl.textContent = engine;
    variantEngineEl.classList.add("variant_engine");

    variantButtonTexts.append(variantBodyEl, variantEngineEl);

    const variantButtonIconContainer = document.createElement("div");
    variantButtonIconContainer.classList.add("variant_button_icon_container");
    variantButtonIconContainer.innerHTML = CART_ICON_SVG;

    variantButton.addEventListener("click", () => {
      atcButton.dataset.atc = variant.id;
      atcButton.dataset.selection = `${pcCode} / ${body}`;
      atcButton.click();
    });

    variantButton.append(variantButtonTexts);
    variantButton.append(variantButtonIconContainer);
    return variantButton;
  }
  function getProductCard(product) {
    // USED FIELDS handle title price compare_at_price variants || variant.title variant.id
    const productCard = document.createElement("div");
    productCard.classList.add("product_card");
    const imageSrc = window.productCardImages.find(
      (item) => item.handle === product.handle
    ).image;
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    const cardInnerHtml = `
                        <img class="product_card_image" src="${imageSrc}" alt="${
      product.handle
    }"/>
                        <a class="product_card_magnifier" href="/products/${
                          product.handle
                        }">${MAGNIFIER_SVG}</a>
                        <p class="product_card_title">${product.title}</p>
                        <p class="product_card_price">${formatter.format(
                          product.price / 100
                        )} <span class="product_card_compare_at_price">${formatter.format(
      product.compare_at_price / 100
    )}</span</p>
                        <div class="product_card_bottom_wrapper">
                            <select name="" id="">
                              ${product.variants.reverse().map((variant) => {
                                const [pcCode, make, model, body, engine] =
                                  variant.title
                                    .split("/")
                                    .map((item) => item.trim());
                                return `<option value="${variant.id}" data-selection="${pcCode} / ${body}">${body}</option>`;
                              })}
                            </select>
                            <button data-role="add-to-cart">${CART_ICON_SVG}</button>
                        </div>
                        `;

    productCard.innerHTML = cardInnerHtml;
    const cardATCButton = productCard.querySelector(
      "button[data-role='add-to-cart']"
    );
    const cardSelectBox = productCard.querySelector("select");
    cardATCButton.addEventListener("click", () => {
      const selected = cardSelectBox.options[cardSelectBox.selectedIndex];
      atcButton.dataset.atc = selected.value;
      atcButton.dataset.selection = selected.dataset.selection;
      atcButton.click();
    });
    return productCard;
  }
});

// METAFIELD VARIANT AND PRODUCTS END
